import {mutations} from './mutations';
import {actions} from './actions';
import {getters} from './getters';

const state = {
    matches: 0,
    executionTime: 0,
    responseRate: 0,
    query: {
        booleanOperation: "must",
        minimumShouldMatch: null,
        conditions: [
            {
                id: null,
                dataVariableId: null,
                operation: 'match',
                value: null,
            }
        ],
        subQueries: [],
    },
    queryReset: {
        booleanOperation: "must",
        minimumShouldMatch: null,
        conditions: [
            {
                id: null,
                dataVariableId: null,
                operation: 'match',
                value: null,
            }
        ],
        subQueries: [],
    },

    queryId: null,
    queryName: '',
    queryType: 'query',
    queryShared: false,
    queryRunning: false,
    queryOwner: null,

    segments: [],
    segmentsCache: null,
    segmentsCacheExpires: null,
    segmentsLoading: false,
    segmentSaving: false,
}

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

